import { render, staticRenderFns } from "./StakingButton.vue?vue&type=template&id=54b50728&scoped=true&"
import script from "./StakingButton.vue?vue&type=script&lang=ts&"
export * from "./StakingButton.vue?vue&type=script&lang=ts&"
import style0 from "./StakingButton.vue?vue&type=style&index=0&id=54b50728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b50728",
  null
  
)

export default component.exports